import { createFileRoute, Outlet } from '@tanstack/react-router'

import { RouteErrorComponent } from '@/features/app-shell/route-error-component'
import { Section, SectionTitle } from '@/features/app-shell/section'
import { GraylogTabs } from '@/features/graylog/components/tabs'
import { graylogQueries } from '@/features/graylog/queries'

import { ROLES } from '@/shared/auth/constants'
import { getCurrentRole, getCurrentTenant } from '@/shared/auth/store'
import { hasRequiredRole } from '@/shared/auth/utils/user'

import { Skeleton } from '@/components/ui/skeleton'

export const Route = createFileRoute('/_dashboard/graylog')({
	loader: ({ context: { queryClient } }) => {
		const tenant = getCurrentTenant()
		const role = getCurrentRole()

		// Prefetch triggered alerts
		if (tenant) {
			queryClient.prefetchQuery(graylogQueries.triggeredAlerts(tenant))

			// Prefetch queries that are only available to Analysts
			if (role && hasRequiredRole(role, ROLES.Analyst)) {
				queryClient.prefetchQuery(graylogQueries.events(tenant))
				queryClient.prefetchInfiniteQuery(
					graylogQueries.automationSettings(tenant),
				)
			}
		}
	},

	head: () => ({
		meta: [
			{
				title: 'Graylog | BitLyft AIR®',
			},
		],
	}),

	component: GraylogRoute,
	pendingComponent: GraylogRouteSkeleton,
	errorComponent: RouteErrorComponent,
	notFoundComponent: GraylogNotFound,
})

function GraylogRoute() {
	return (
		<Section>
			<SectionTitle>Graylog</SectionTitle>
			<GraylogTabs />

			<Outlet />
		</Section>
	)
}

function GraylogRouteSkeleton() {
	return (
		<Section>
			<SectionTitle>Graylog</SectionTitle>
			<GraylogTabs />
			{Array.from({ length: 24 }).map((_, i) => (
				<Skeleton key={i} className="my-2 h-12 w-full" />
			))}
		</Section>
	)
}

function GraylogNotFound() {
	return (
		<div className="text-center">
			<h1 className="text-3xl">Page not found</h1>
			<h2 className="my-2 text-xl">
				We couldn't find the page you were looking for.
			</h2>
			<p>Please use the navigation above to find what you're looking for.</p>
		</div>
	)
}
